import { AppThunk } from '../core-store';
import { setActiveAnswer } from '../slices/answers/answers-slice';

export const restoreFocus = (): AppThunk => (dispatch, getState) => {
    const { prevAnswerUuid } = getState().answers;

    requestAnimationFrame(() => dispatch(setActiveAnswer(prevAnswerUuid)));
};
